import { AnswerContent } from '..'

export function detectYoutube(
  content: AnswerContent
): content is AnswerContent & { meta: { type: 'video:youtube' } } {
  return content.meta?.type === 'video:youtube'
}

// https://developers.google.com/youtube/player_parameters#Parameters
interface Option {
  rel?: '0' | '1'
  origin?: string
}
export function getEmbedUrlForId(id: string | null, options?: Option) {
  if (!id) return ''
  const url = new URL(`https://www.youtube.com/embed/${id}`)
  if (options?.rel) {
    url.searchParams.set('rel', options.rel)
  }
  if (typeof options?.origin !== 'undefined') {
    url.searchParams.set('origin', options?.origin)
  }
  return url.href
}
